export const mockups = {
    //отфильтрованные продукты
    filteredProducts:  [
        {
            name: 'Фильтрованный товар1',
            img: './img/mockups/mainPage/popular-product-1.jpg',
            isDiscount: false,
            discountPrice: '',
            price: 7777,
            link: '#1'
        },
        {
            name: 'Фильтрованный товар2',
            img: './img/mockups/mainPage/popular-product-2.jpg',
            isDiscount: true,
            discountPrice: '3333',
            price: 8888,
            link: '#2'
        },
        {
            name: 'Фильтрованный товар3',
            img: './img/mockups/mainPage/popular-product-3.jpg',
            isDiscount: true,
            discountPrice: '5555',
            price: 8888,
            link: '#2'
        },
        {
            name: 'Фильтрованный убор для кота3',
            img: './img/mockups/mainPage/popular-product-1.jpg',
            isDiscount: false,
            discountPrice: '',
            price: 10000,
            link: '#2'
        }
    ],

    //получение продуктов по скроллу
    scrollProducts: {
        payload: {
            products: [
                {
                    name: 'Товар2',
                    img: './img/mockups/mainPage/popular-product-1.jpg',
                    isDiscount: false,
                    discountPrice: '',
                    price: 7777,
                    link: '#1'
                },
                {
                    name: 'Фильтрованный товар3',
                    img: './img/mockups/mainPage/popular-product-2.jpg',
                    isDiscount: true,
                    discountPrice: '3333',
                    price: 8888,
                    link: '#2'
                },
                {
                    name: 'Фильтрованный товар4',
                    img: './img/mockups/mainPage/popular-product-3.jpg',
                    isDiscount: true,
                    discountPrice: '5555',
                    price: 8888,
                    link: '#2'
                },
                {
                    name: 'Фильтрованный товар5',
                    img: './img/mockups/mainPage/popular-product-1.jpg',
                    isDiscount: false,
                    discountPrice: '',
                    price: 10000,
                    link: '#2'
                }
            ],
            status: 'success'
        },
        resultCode: '200'
    },

    //добавление в корзину
    addToCart: {
        payload: {
            status: 'success'
        },
        resultCode: '200'
    },

    //корзина
    cart:{
        payload: {
            cartItems:[
                {
                    itemCartId:'123',
                    name: 'Товар 1',
                    img: './img/mockups/mainPage/popular-product-1.jpg',
                    isDiscount: false,
                    discountPrice: '0',
                    price: 390,
                    link: '#1',
                    chosenSize: 'm',
                    count: 1,
                    maxCount: 2,
                    productId: 123
                },
                {
                    itemCartId: '321',
                    name: 'Товар 2213123123 1231231 123123123 1231231 123',
                    img: './img/mockups/mainPage/popular-product-2.jpg',
                    isDiscount: true,
                    discountPrice: '3000',
                    price: 4000,
                    link: '#2',
                    chosenSize: 'xl',
                    count: 5,
                    maxCount: 5,
                    productId: 321
                },
            ],
            user:{
                name:'',
                phone: '',
                email:'123@mail.ru',
                lastname: "",
                city: "",
                address: "",
                countBonus:'0',
            },
            status: 'success',
            storages: [
                {
                    id: 1,
                    name: 'Вишнёвый'
                }
            ],
            deliveryAvailability: true,
            canUsePromoCode: true
        },
        resultCode: '200'
    },

    //удаление товара из корзины
    removeCartItem:{
        payload: {
            cartItems:[
                {
                    itemCartId:'123',
                    name: 'Товар 1',
                    img: './img/mockups/mainPage/popular-product-1.jpg',
                    isDiscount: false,
                    discountPrice: '0',
                    price: 5000,
                    link: '#1',
                    chosenSize: 'm',
                    count: 1,
                    maxCount: 2
                },
                {
                    itemCartId:'321',
                    name: 'Товар 2',
                    img: './img/mockups/mainPage/popular-product-2.jpg',
                    isDiscount: true,
                    discountPrice: '3000',
                    price: 4000,
                    link: '#2',
                    chosenSize: 'xl',
                    count: 1,
                    maxCount: 1
                },
            ],
            storages: [
                {
                    id: 1,
                    name: 'Вишнёвый'
                }
            ],
            deliveryAvailability: true,
            user:{
                name:'Василий',
                phone: '',
                email:'1@ro.ru',
                lastname: "Дядин",
                city: "Самара",
                address: "Кирова 103",
                countBonus:'0',
            },
            status: 'success'
        },
        resultCode: '200'
    },

    //изменение товара в корзине
    editCartItem:{
        payload: {
            cartItems:[
                {
                    itemCartId:'123',
                    name: 'Товар 1',
                    img: './img/mockups/mainPage/popular-product-1.jpg',
                    isDiscount: false,
                    discountPrice: '0',
                    price: 5000,
                    link: '#1',
                    chosenSize: 'm',
                    count: 1,
                    maxCount: 1
                },
                {
                    itemCartId:'321',
                    name: 'Товар 2',
                    img: './img/mockups/mainPage/popular-product-2.jpg',
                    isDiscount: true,
                    discountPrice: '3000',
                    price: 4000,
                    link: '#2',
                    chosenSize: 'xl',
                    count: 1,
                    maxCount: 1
                },
            ],
            user:{
                name:'Василий',
                phone: '',
                email:'1@ro.ru',
                lastname: "Дядин",
                city: "Самара",
                address: "Кирова 103",
                countBonus:'0',
            },
            storages: [
                {
                    id: 1,
                    name: 'Вишнёвый'
                }
            ],
            deliveryAvailability: true,
            status: 'success'
        },
        resultCode: '200'
    },

    //подтверждение заказа
    sendOrder:{
        payload: {
            status: 'success'
        },
        resultCode: '200'
    },

    //получение статуса оплаты
    sendPaymentStatus: {
        payload: {
            status: "success"
        },
        resultCode: "200"
    },

    //проверка пароля
    checkPassword: {
        "status": "success", // "expired" - код истек, "incorrect" - код некорректный
        "completedProfile": true // false флаг заполненности профиля
    },

    //отправка пароля на почту
    sendPassword: [],

    //получение цены доставки
    getDeliveryValues :{
        status: "success",
        pay: 333.33,
        paynds: 400.11,
        days: 10
    },

    //получение бонусов
    getBonuses:{
        "status": "OK",
        "payload": {
            "count": 10012,
            "maxWriteOff": 1259,
            "maxAccrue": 1008,
            "bonusLevel": {
                "id": 2,
                "name": "Белый",
                "sumFrom": 500,
                "percentAddTicket": 25,
                "percentSubTicket": 30,
                "percentAddShop": 20,
                "percentSubShop": 25,
                "apiCode": "silver"
            },
            "promoCode": {
                "discount_type": "percent",
                "discount_value": 10,
                "message": "Обращаем ваше внимание, что далее содержится очень длинный текст по списанию >30%, чего категорически делать нельзя, поэтому спишем вам намного меньше, чем вы хотели"
            },
            "amountPay": {
                "writeOff": 4046,
                "accrue": 5392,
                "fullPrice": 6000
            }
        }
      /*  status: 'error',
        statusText: "Ошибка применения промокода"*/
    },

    //получение профиля пользователя
    getUserProfile: {
        "id": "7",
        "username": null,
        "name": 'Куламита1',
        "lastname": 'Куламита2',
        "dateBirthday": null,
        "phone": null,
        "email": "topice4@gmail.com",
        "city": 'Куламита3',
        "address":'Куламита4',
        "sex": null
    },

    //промокод
    validatePromocode:{
        success:{
            payload: {
                promocode:{
                    discount_value: 25,
                    discount_type: '%',
                    min_value: 1000
                },
                status: "success"
            },
            resultCode: "200"
        },
        error:{
            payload: {
                status: "error",
                errorText: "Срок действия промокода истек Срок действия промокода истек"
            },
            resultCode: "200"
        }
    }
}